import { ItemAttributesMappingBase } from './base/item-attributes-mapping-base';

export class ItemAttributesMapping extends ItemAttributesMappingBase { }